module.exports = __webpack_public_path__ + "static/assets/c5bf2c69d9aa45ae8f63cb177b82dcfd.svg";